'use client'
import Template from 'app/[template]/layout'
import Page from 'app/[template]/page'
import { usePathname } from 'next/navigation'
import Map from 'components/Map'

const FCPPage = () => {
  const pathname = usePathname()
  return (
    <>
      <Template />
      {pathname.includes('contacte') && <Map />}
      <Page />
    </>
  )
}

export default FCPPage
